<ul class="requirements" *ngIf="showRequirements()">
  <li *ngFor="let key of getRequirementKeys()" [class.kh-small-text]="true" [class.requirement]="true" [class.requirement--met]="isRequirementMet(key)" [class.requirement--missing]="isRequirementUnmetMessageShowable(key)">
    {{ getRequirementMessageByKey(key) }}
  </li>
</ul>
